import { LinkButton } from 'components/core-v2'
import { DateObject } from 'react-multi-date-picker'

import ClearIcon from '../../../../assets/clear.svg?react'
import { BodyProps } from '.'
import classes from './index.module.scss'

export const ClearDatesButton = ({
  defaultValue,
  onChange
}: Pick<BodyProps<[Date, Date]>, 'onChange' | 'defaultValue'>) => (
  <LinkButton
    underline
    className={classes.clearDatesButton}
    onClick={() => onChange([new DateObject(defaultValue[0]), new DateObject(defaultValue[1])])}
  >
    <ClearIcon className="mr-half" /> Clear dates
  </LinkButton>
)
